// extracted by mini-css-extract-plugin
module.exports = {"root":"SplitButton_root__2y9nq","dropdownPart":"SplitButton_dropdownPart__RSrTh","menu":"SplitButton_menu__1ex6U"};